export default function () {
	return {
		link: function ($scope, $element) {
			$element.on('click', function (e) {
				e.stopPropagation();
			});
		}
	};
}
